import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RegionModalService {

  private selectedRegionSubject = new BehaviorSubject<any>(null);
  public selectedRegion$ = this.selectedRegionSubject.asObservable();

  constructor() { }

  setSelectedRegion(region: any): void {
    this.selectedRegionSubject.next(region);
  }

  getSelectedRegion(): any | null {
    return this.selectedRegionSubject.value;
  }

  clearSelectedRegion(): void {
    this.selectedRegionSubject.next(null);
  }
}
